import { SortBy, SubsectionsButtonsOptions } from '@common/enums';
import { Filter } from '@common/models';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../store';

export type CookingApplianceFilters = Record<string, Filter>;

export type PredefinedCookingAppliance = {
    id: number;
    // TODO: fix typing
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    image: any;
    title: string;
};

interface CookingAppliancesState {
    selectedCookingApplianceOption?: SubsectionsButtonsOptions;
    selectedCookingApplianceId?: number;
    cookingApplianceFilters?: CookingApplianceFilters;
    sortBy?: SortBy;
}

const initialState: CookingAppliancesState = {
    selectedCookingApplianceOption: undefined,
    selectedCookingApplianceId: undefined,
    cookingApplianceFilters: undefined,
    sortBy: SortBy.None,
};

const cookingApplianceSlice = createSlice({
    name: 'cookingAppliance',
    initialState,
    reducers: {
        resetCookingAppliances: (state) => {
            state.selectedCookingApplianceOption = initialState.selectedCookingApplianceOption;
            state.selectedCookingApplianceId = initialState.selectedCookingApplianceId;
            state.cookingApplianceFilters = initialState.cookingApplianceFilters;
        },
        updateSelectedCookingApplianceOption: (state, action: PayloadAction<SubsectionsButtonsOptions>) => {
            state.selectedCookingApplianceOption = action.payload;
        },
        resetSelectedCookingApplianceOption: (state) => {
            state.selectedCookingApplianceOption = undefined;
        },
        updateSelectedCookingApplianceId: (state, action: PayloadAction<number>) => {
            state.selectedCookingApplianceId = action.payload;
        },
        resetSelectedCookingApplianceId: (state) => {
            state.selectedCookingApplianceId = undefined;
        },
        updateCookingApplianceFilters: (state, action: PayloadAction<CookingApplianceFilters>) => {
            state.cookingApplianceFilters = action.payload;
        },
        updateCookingApplianceSortBy: (state, action: PayloadAction<SortBy | undefined>) => {
            state.sortBy = action.payload;
        },
    },
});

export const {
    resetCookingAppliances,
    updateSelectedCookingApplianceOption,
    resetSelectedCookingApplianceOption,
    updateSelectedCookingApplianceId,
    resetSelectedCookingApplianceId,
    updateCookingApplianceFilters,
    updateCookingApplianceSortBy,
} = cookingApplianceSlice.actions;

export const selectSelectedCookingApplianceOption = ({
    cookingAppliance,
}: RootState): SubsectionsButtonsOptions | undefined => {
    return cookingAppliance.selectedCookingApplianceOption;
};

export const selectSelectedCookingApplianceId = ({ cookingAppliance }: RootState): number | undefined => {
    return cookingAppliance.selectedCookingApplianceId;
};

export const selectCookingApplianceFilters = ({ cookingAppliance }: RootState): CookingApplianceFilters | undefined => {
    return cookingAppliance.cookingApplianceFilters;
};

export const selectCookingApplianceSortBy = ({ cookingAppliance }: RootState): SortBy | undefined => {
    return cookingAppliance.sortBy;
};

export default cookingApplianceSlice.reducer;
